<template>
    <div :v-if="display">
      <component :is="layout">
        <router-view :key="$route.fullPath"></router-view>
      </component>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

const defaultLayout = 'guest'
export default {
  computed: {
    ...mapState({
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    })
  },

  data () {
    return {
      display: false
    }
  },

  methods: {
    ...mapActions('dev', ['load']),
    ...mapActions('meta', [])
  },
  created () {
    // Load dev mode on/off
    const promises = []
    promises.push(this.load())

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue